export enum AppRouteURL {

    //Generic route URL

    NotFound = "/not-found",

    // Public route URL
    HomePage = "/",
    ContactPage = "/contact",
    BenefitPage = "/benefit",
    TryItPage="/tryit",
    Login = "/login",
    ForgotPassword = "/forgot-password",
    Playground = "/playground",

    //Private route URL
    Dashboard = "/dashboard",
    
  }